export abstract class UserStorage {
	public abstract setItem(key: string, value: any): void;

	public abstract getItem(key: string): any;

	public abstract getKey(key: number): any;

	public abstract removeItem(key: string): void;

	public abstract hasItem(key: string): boolean;

	public abstract each(key: string): any;
}

export class BaseStorage implements UserStorage {
	public setItem(key: string, value: any): void {
		localStorage.setItem(key, value);
	}

	public getItem(key: string): any {
		return localStorage.getItem(key);
	}

	public getKey(key: number): any {
		return localStorage.key(key);
	}

	public removeItem(key: string): void {
		localStorage.removeItem(key);
	}

	public hasItem(key: string): boolean {
		return localStorage.hasItem(key);
	}

	public each(key: string): any {
	}

	public clear(): void {
		localStorage.clear();
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/logic/Storage.ts